import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PerfilRecursoSeguranca } from './perfil-recurso-seguranca.model';
import {BaseService} from '../services/base-service.service';

@Injectable()
export class PerfilRecursoSegurancaService extends BaseService<PerfilRecursoSeguranca, number> {


  constructor(http: HttpClient) {
    super('perfilRecursoSeguranca', http);
  }
  public newEntity(): PerfilRecursoSeguranca {
    return {};
  }

  public getId(entity: PerfilRecursoSeguranca): number {
    return entity.id;
  }
}
